// App.js
import React from "react";
import styled from "styled-components";
import picAryan from "./images/profile-pic-Aryan.png";
import picAnshul from "./images/profile-pic-anshul.png";
import picAnkur from "./images/profile-pic-ankur.png";

const TeamSection = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;

  width: 80%;
  margin: auto;
  // justify-content: space-evenly;
  align-items: center;
  background-color: var(--secondary-color);
  padding: 2% 1%;

  @media (min-width: 768px) {
    padding: 2%;
  }
`;

const TeamMember = styled.div`
  text-align: center;
  width: 100%;
  margin-bottom: 10%;

  @media (min-width: 768px) {
    width: 45%;
  }

  @media (min-width: 1024px) {
    width: 30%;
  }
`;

const TeamMemberImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
`;

const TeamMemberName = styled.h3`
  margin: 4% 0;
`;

const TeamMemberRole = styled.p`
  color: #777;
`;

const App = () => {
  return (
    <div className="about-us-container" id="scroll-to-about-page">
      <div className="about-us-content">
        <h2 className="main-heading">About Us</h2>
        <div className="about-us-section">
          <div className="about-us-text">
            <p>
              <span>Fitness Junction</span> is the culmination of our team's
              unwavering dedication to promoting a healthier lifestyle through
              accessible and informative resources. As a collective of
              passionate individuals, we have meticulously crafted this platform
              to serve as a comprehensive library of exercises catering to all
              fitness enthusiasts, whether they are looking to exercise at home
              or master specific equipment.
            </p>

            <p>
              With a keen focus on functionality, Fitness Junction allows users
              to search for exercises based on targeted muscle groups, providing
              a tailored approach to fitness education. Whether one is aiming to
              strengthen their back or tone their lower arms, our platform
              offers step-by-step instructions accompanied by vivid
              illustrations, ensuring clarity and effectiveness in every
              workout.
            </p>
          </div>
          <div className="about-us-image">
            <img
              src="https://images.pexels.com/photos/416778/pexels-photo-416778.jpeg"
              alt="Team"
            />
          </div>
        </div>
      </div>

      {/* //cards */}

      <h2 className="main-heading">Our Team</h2>

      <TeamSection>
        <TeamMember>
          <TeamMemberImage src={picAnshul} alt="Team Member 1" />
          <TeamMemberName>Anshul Gora</TeamMemberName>
          <TeamMemberRole>Fullstack Developer</TeamMemberRole>
          <TeamMemberRole>FinalYear Student</TeamMemberRole>
        </TeamMember>

        <TeamMember>
          <TeamMemberImage src={picAryan} alt="Team Member 2" />
          <TeamMemberName>Aryan Mishra</TeamMemberName>
          <TeamMemberRole>Fullstack Developer</TeamMemberRole>
          <TeamMemberRole>FinalYear Student</TeamMemberRole>
        </TeamMember>

        <TeamMember>
          <TeamMemberImage src={picAnkur} alt="Team Member 3" />
          <TeamMemberName>Ankur Yadav</TeamMemberName>
          <TeamMemberRole>Fullstack Developer</TeamMemberRole>
          <TeamMemberRole>FinalYear Student</TeamMemberRole>
        </TeamMember>

        <TeamMember>
          <h2 className="main-heading">Mentor</h2>
          {/* <TeamMemberImage src="mentor.jpg" alt="Mentor" /> */}
          <TeamMemberName>Mrs. Richa Sharma</TeamMemberName>
          <TeamMemberRole>Assistant Professor, CSE</TeamMemberRole>
          {/* <TeamMemberRole>Mentor</TeamMemberRole> */}
        </TeamMember>
      </TeamSection>
    </div>
  );
};

export default App;
